let unique = 1;

export function DateOperations(date, operations, isOpen) {
    unique += 1;
    this.unique = `date-${unique}`;

    this.name = date;
    this.operations = operations;
    this.open = isOpen;

    this.resume = null;

    if (this.operations.length > 1) {
        let salary = 0;
        let dynamic = 0;
        let bonus = 0;
        let penalty = 0;
        let amount = 0;

        this.operations.forEach((operation) => {
            salary += operation.salary;
            dynamic += operation.dynamic;
            bonus += operation.bonus;
            penalty += operation.penalty;
            amount += operation.amount;
        });

        this.resume = {
            dayStartBalance: this.operations[0].dayStartBalance,
            dayEndBalance: this.operations[this.operations.length-1].dayEndBalance,
            created: "",
            salary,
            dynamic,
            bonus,
            penalty,
            amount,
        };
    }
}

export function groupOperationsByDate(data, print) {
    const dates = {};

    data.forEach((operation) => {
        const { date } = operation;

        if (!dates[date]) {
            dates[date] = [];
        }

        dates[date].push(operation);
    });

    return Object.entries(dates).map(([key, value]) => new DateOperations(key, value, print));
}
